// src/components/Dashboard/swapembede.jsx

import React, { useState } from 'react';
import { Card, Nav, Alert } from 'react-bootstrap';
import { CONTRACTS } from './utils/constants';
import './styles/PancakeSwapEmbed.css';

const PancakeSwapEmbed = () => {
  const [activeTab, setActiveTab] = useState('swap');

  // PancakeSwap URLs with BOTH tokens specified
  // inputCurrency = USDT (what user sells)
  // outputCurrency = FNT (what user buys)
  const swapUrl = `https://pancakeswap.finance/swap?inputCurrency=${CONTRACTS.USDT}&outputCurrency=${CONTRACTS.FONTANA}&chain=bscTestnet`;
  
  // Liquidity URL - Uses YOUR LP pool
  const liquidityUrl = `https://pancakeswap.finance/add/${CONTRACTS.USDT}/${CONTRACTS.FONTANA}?chain=bscTestnet`;
  
  // Pool info URL - Shows YOUR pool stats
  const poolUrl = `https://pancakeswap.finance/info/v2/pairs/${CONTRACTS.LP_PAIR}?chain=bscTestnet`;

  const getActiveUrl = () => {
    switch(activeTab) {
      case 'swap':
        return swapUrl;
      case 'liquidity':
        return liquidityUrl;
      case 'pool':
        return poolUrl;
      default:
        return swapUrl;
    }
  };

  // Determine iframe height based on screen size
  const getIframeHeight = () => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth < 576) {
        return '400px'; // Mobile
      } else if (window.innerWidth < 992) {
        return '500px'; // Tablet
      }
    }
    return '600px'; // Desktop
  };

  const [iframeHeight, setIframeHeight] = React.useState(getIframeHeight());

  React.useEffect(() => {
    const handleResize = () => {
      setIframeHeight(getIframeHeight());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <Card className="pancake-swap-card">
      <Card.Body>
        <h5 className="card-title">Trade & Manage Liquidity (PancakeSwap)</h5>
        <p className="text-muted small mb-3">
          Interact with Fontana LP Pool on PancakeSwap (BSC Testnet)
        </p>

        {/* Important Notice */}
        {activeTab === 'swap' && (
          <Alert variant="info" className="swap-alert">
            <strong>💡 Trading Pair:</strong> USDT → FNT (Buying FNT with USDT)<br/>
           </Alert>
        )}

        {/* Tabs */}
        <Nav variant="tabs" className="pancake-nav">
          <Nav.Item>
            <Nav.Link 
              active={activeTab === 'swap'}
              onClick={() => setActiveTab('swap')}
              style={{ cursor: 'pointer' }}
              className="nav-tab"
            >
              Swap
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              active={activeTab === 'liquidity'}
              onClick={() => setActiveTab('liquidity')}
              style={{ cursor: 'pointer' }}
              className="nav-tab"
            >
              Add/Remove Liquidity
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link 
              active={activeTab === 'pool'}
              onClick={() => setActiveTab('pool')}
              style={{ cursor: 'pointer' }}
              className="nav-tab"
            >
              Pool Info
            </Nav.Link>
          </Nav.Item>
        </Nav>

        {/* Info based on active tab */}
        <div className="tab-info">
          <small className="text-muted">
            {activeTab === 'swap' && '💱 Buy or sell FNT tokens with USDT'}
            {activeTab === 'liquidity' && '💧 Add or remove liquidity from FNT-USDT pool'}
            {activeTab === 'pool' && '📊 View pool statistics and trading data'}
          </small>
        </div>
        
        {/* Embedded PancakeSwap */}
        <div className="iframe-container" style={{ height: iframeHeight }}>
          <iframe
            src={getActiveUrl()}
            width="100%"
            height="100%"
            style={{ border: 'none' }}
            title="PancakeSwap"
            allow="clipboard-write"
            sandbox="allow-same-origin allow-scripts allow-popups allow-forms"
            key={activeTab}
          />
        </div>

        {/* Pool Address Reference */}
        <div className="pool-info">
          <small>
            <strong>Your LP Pool:</strong>{' '}
            <code className="code-block">{CONTRACTS.LP_PAIR}</code>
            <br/>
            <strong>Trading Pair:</strong>{' '}
            <span className="badge bg-primary">FNT-USDT</span>
          </small>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PancakeSwapEmbed;